import React, { useEffect, useState } from "react";
import "./component.css";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import leftArrow from "../../../assests/leftArrow.svg";
import Table from "react-bootstrap/Table";
import search from "../../../assests/search.svg";
import eyeIcon from "../../../assests/eyeIcon.svg";
import filterIcon from "../../../assests/filterIcon.svg";
import { FormControl, FormControlLabel, Checkbox } from "@mui/material";
import { toastr } from "react-redux-toastr";
import { toast } from "react-toastify";
import LoadingSpinner from "../../Loading/component";
import dayjs from "dayjs";
import TextField from "@mui/material/TextField";
import InfiniteScroll from "react-infinite-scroll-component";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import retryicon from "../../../assests/retryicon.svg";
import CircularProgress from "@mui/material/CircularProgress";
import uploadsvg from "../../../assests/uploadsvg.svg";
import PropTypes from "prop-types";
import unableImage from "../../../assests/unableImage.svg";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { useParams } from "react-router-dom";

import Box from "@mui/material/Box";
import emotions7 from "../../../assests/emotions7.svg";
import moment from "moment-timezone";
import {
  LocalizationProvider,
  DatePicker,
  TimePicker,
} from "@mui/x-date-pickers";
import Modal from "@mui/material/Modal";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
// const style = {
//   position: "absolute",
//   top: "20%",
//   left: "60%",
//   transform: "translate(-50%, -50%)",
//   width: 200,
//   height: 300,
//   bgcolor: "background.paper",
//   border: "2px solid #000",
//   boxShadow: 24,
//   p: 2,
//   overflowY: "scroll",
// };

const OrdersListComp = ({
  filteredCityList,
  onSearchInputChange,
  loading,
  fetchOrderListNext,
  data,
  handleDateChange,
  handleOpen,
  pickDate,
  rowColors,
  handleDrag,
  handleDrop,
  onButtonClick,
  inputRef,
  imageDropped,
  previewImage,
  handleClickImg,
  handleCloseD,
  handleChangeImage,
  orderFound,
  handleRetry,
  handleClickOpen,
  showFileInput,
  open,
  handleFocus,
  handleBlur,
  onSearchInputKeyDown,
  searchOrderValue,
  isLoading,
  searchOption,
  tableContainerRef,
  orderSearchViaCity,
  handleClose,
  openFilter,
  filteredList,
  handleOpenAmount,
  openFilterAmount,
  orderSearchViaAmount,
  handleFilterClick,
  handleApply,
  startTime,
  setStartTime,
  endTime,
  setEndTime,
  onSearchClick,
  handleCheckboxChange,
  selectedCity,
  selectedAmount,
  removeDuplicates,
  handleCancelSelection,
  handleEndTimeChange,
  handleStartTimeChange,
  searchAmountValue,
  handleAmountInputChange,
  handleApplyFilter

}) => {
  const { orderid } = useParams();

  const [showDatePicker, setShowDatePicker] = useState(false);

  const [ctlist, setctlist] = useState(null);
  const uniqueCities = removeDuplicates(ctlist, "city");
  const uniqueAmounts = removeDuplicates(ctlist, "amount");

  useEffect(() => {
    if (!ctlist || !ctlist[0]) {
      setctlist(filteredList);
    }
  }, [filteredList]);

  const handleRowClick = (e, orderid) => {
    navigate(`/home/ordersview/${orderid}`);
  };

  function handleFilterClick() {
    setShowDatePicker(!showDatePicker);
  }

  const navigate = useNavigate();

  const arrowClick = () => {
    navigate("/");
  };
  const handleCancel = () => {
    setShowDatePicker(!showDatePicker);
  };

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
  }));
  console.log("Filtered List Count:", filteredList.length);

  function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={() => {
              handleRetry();
              onClose();
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  }

  BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
  };

  return (
    <>
      {isLoading ? (
        <>
          <LoadingSpinner />
        </>
      ) : (
        <div className="main-div">
          <div>
            <Sidebar />
          </div>

          <div style={{ margin: "auto", width: "100%" }}>
            <div className="ordersHeading">
              <img
                onClick={arrowClick}
                style={{ width: "22px", cursor: "pointer" }}
                src={leftArrow}
                alt=""
              />
              <p className="ordersText">Orders</p>
            </div>
            {isLoading && (
              <div>
                {" "}
                <Box sx={{ display: "flex", color: "yellow" }}>
                  {/* <CircularProgress /> */}
                  <LoadingSpinner />
                </Box>
              </div>
            )}

            <div
              style={{
                display: "flex",
                flexDirection: " row",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div>
                <div className="order-searchbar">
                  <input
                    className="inputfirlf"
                    type="search"
                    placeholder="Search by Mobile Number / Search by Order ID / Mini Order ID"
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    value={searchOrderValue}
                    onChange={onSearchInputChange}
                    onKeyDown={onSearchInputKeyDown}
                  />

                  <button className="search-icon" onClick={onSearchClick}>
                    <img src={search} alt="" />
                  </button>
                </div>
              </div>

              <div
                style={{ position: "relative", top: "80px", right: "10px" }}
                className="uploadimg"
              >
                <Stack direction="row" spacing={2}>
                  <Button onClick={handleClickOpen}>
                    <img
                      src={uploadsvg}
                      alt=""
                      style={{ marginRight: "10px" }}
                    />
                    <span className="uploadtext" style={{ color: "#fff" }}>
                      Upload Screenshot
                    </span>
                  </Button>
                </Stack>
              </div>
            </div>

            <div>
              <BootstrapDialog
                onClose={handleCloseD}
                aria-labelledby="customized-dialog-title"
                open={open}
              >
                <BootstrapDialogTitle
                  id="customized-dialog-title"
                  onClose={handleCloseD}
                >
                  <div style={{ padding: "24px" }}>
                    <p className="uploadHead">Upload Screenshot</p>
                    <Typography>
                      Upload the screenshot of payment transaction
                    </Typography>
                  </div>
                </BootstrapDialogTitle>
                <DialogContent id="form-file-upload">
                  {orderFound ? (
                    <div>
                      <div
                        className="dragDropBox"
                        onDrop={handleDrop}
                        onDragEnter={handleDrag}
                        onDragOver={handleDrag}
                        onDragLeave={handleDrag}
                        onClick={(e) => onButtonClick(e, "box")}
                      >
                        {previewImage ? (
                          <div
                            style={{
                              height: "350px ",
                              margin: "10px",
                              width: "100%",
                            }}
                          >
                            <img
                              src={previewImage}
                              alt="Preview"
                              style={{ maxWidth: "100%", maxHeight: "100%" }}
                            />
                          </div>
                        ) : (
                          <div
                            style={{
                              margin: "auto",
                              textAlign: "center",
                              alignItems: "center",
                            }}
                          >
                            <p className="boxheading">
                              Drop screenshot here, or{" "}
                              <a
                                onClick={(e) => onButtonClick(e, "button")}
                                href=""
                                style={{
                                  textDecoration: "none",
                                  marginLeft: "4px",
                                }}
                              >
                                {" "}
                                Browse{" "}
                              </a>
                            </p>
                          </div>
                        )}
                        <div
                          style={{
                            position: "fixed",
                            margin: "auto",
                            width: "711px",
                          }}
                        >
                          {imageDropped && (
                            <div style={{ marginTop: "20px" }}>
                              <Button
                                onClick={(e) => onButtonClick(e, "button")}
                                className="changeimage-button"
                              >
                                change image
                              </Button>
                            </div>
                          )}
                        </div>
                      </div>

                      {previewImage ? (
                        <div style={{ marginTop: "50px" }}>
                          <Button
                            onClick={handleClickImg}
                            type="submit"
                            disabled={loading || !previewImage}
                            variant="contained"
                            color="success"
                            size="large"
                            style={{ marginLeft: "0px", width: "100%" }}
                          >
                            {loading ? (
                              <CircularProgress size={24} />
                            ) : (
                              "Submit"
                            )}
                          </Button>
                        </div>
                      ) : (
                        <div style={{ marginTop: "50px" }}>
                          <Button
                            //  onClick={handleClickImg}
                            type="submit"
                            disabled={true}
                            variant="secondary"
                            color="success"
                            size="large"
                            style={{
                              marginLeft: "0px",
                              width: "710px",
                              display: "none",
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      )}

                      <div
                        style={{ display: showFileInput ? "block" : "none" }}
                      >
                        <input
                          ref={inputRef}
                          // id="input-file-upload"
                          id="myFileInput"
                          multiple={true}
                          type="file"
                          onChange={handleChangeImage}
                          style={{ display: "none" }}
                        />
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div>
                        <img src={unableImage} alt="" />
                        <h4 style={{ textTransform: "capitalize" }}>
                          Unable to find order id
                        </h4>
                      </div>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRetry(orderFound);
                        }}
                      >
                        Retry <img src={retryicon} alt="" />
                      </a>

                      {showFileInput && (
                        <div>
                          <input
                            ref={inputRef}
                            id="myFileInput"
                            multiple={true}
                            type="file"
                            onChange={handleChangeImage}
                            style={{ display: "none" }}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </DialogContent>
              </BootstrapDialog>
            </div>

            <div className="order-left-sec">
            <div className="dateFilterPlacement">
  <div style={{ marginTop: "20px" }}>
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          padding: 1,
          borderRadius: 1,
          alignItems: "center",
        }}
      >
        <DatePicker
          label="Select Date"
          value={pickDate}
          onChange={handleDateChange}
          maxDate={moment()}
          renderInput={(params) => (
            <TextField
              {...params}
              style={{ width: "157px", height:"74px", marginTop:"20px" }}
              inputProps={{
                ...params.inputProps,
                readOnly: true,
              }}
              placeholder="Select Date"
            />
          )}
        />

        {/* Start Time Picker */}
        <TimePicker
          label="Start Time"
          value={startTime}
          onChange={handleStartTimeChange}
          renderInput={(params) => (
            <TextField
              {...params}
              style={{ width: "150px", height:"74px", marginTop:"20px" }}
              placeholder="Start Time"
            />
          )}
        />

        <TimePicker
          label="End Time"
          value={endTime}
          onChange={handleEndTimeChange}
          renderInput={(params) => (
            <TextField
              {...params}
              style={{ width: "150px" , height:"74px", marginTop:"20px"}}
              placeholder="End Time"
            />
          )}
        />
      </Stack>
    </LocalizationProvider>
  </div>

  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginLeft: "120px" , marginTop:"20px"}}>
    <label htmlFor="" style={{ marginBottom: "5px", fontWeight:500 }}>Amount</label>
    <div style={{backgroundColor:"#fff", borderRadius:"12px", padding:"2px"}}>
      Rs.
      <input
      style={{
        borderRadius: "12px",
        width: "100px",
        // border: "1px solid #ccc",
        // borderBottom: "1px solid #ccc",
        outline: "none",
        textAlign: "center",
        border:"none"
      }}
      type="number"
      placeholder=" _ _ _"
      value={searchAmountValue}
      onChange={handleAmountInputChange}
      maxLength={5}
    />
    </div>
    
  </div>

  <div style={{ display: "flex", alignItems: "center", marginLeft: "20px", marginTop:"50px" }}>
    <Button
      style={{
        width: "80px",
        fontSize: "14px",
        backgroundColor: "#14AE78",
        color: "#fff",
        marginRight: "10px",
      }}
      onClick={handleApplyFilter}
    >
      Apply
    </Button>

    <Button
      onClick={handleCancelSelection}
      variant="outlined"
      style={{
        width: "80px",
        fontSize: "14px",
        color: "#14AE78",
        borderColor: "#14AE78",
      }}
    >
      Reset
    </Button>
  </div>
</div>

             
              <div style={{ backgroundColor: "#fff", borderRadius: "14px" }}>
                <div>
                  {/* <InfiniteScroll
                    dataLength={data.length}
                    next={fetchUsersListNext}
                    hasMore={true}
                    scrollableTarget="scrollableDiv"
                    height={700}
                    endMessage={
                      <p style={{ textAlign: "center" }}>
                        <b>Yay! You have seen it all</b>
                      </p>
                    }
                  > */}
                  <div>
                    <Modal
                      open={openFilter}
                      onClose={handleClose}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                    >
                      <Box className="cityfilterClass">
                        <Typography variant="h6" component="h2" gutterBottom>
                          Filter by City
                        </Typography>
                        {isLoading ? (
                          <CircularProgress />
                        ) : (
                          <FormControl component="fieldset">
                            {uniqueCities &&
                              uniqueCities.map((item) => (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={selectedCity === item.city}
                                      onChange={() =>
                                        handleCheckboxChange(item.city, "city")
                                      }
                                    />
                                  }
                                  label={item.city}
                                  key={item.city}
                                />
                              ))}
                          </FormControl>
                        )}
                      </Box>
                    </Modal>
{/* <div>
   <input type="search" placeholder="Search amount" value={searchAmountValue} onChange={handleAmountInputChange} />
</div> */}
                    {/* <Modal
                      open={openFilterAmount}
                      onClose={handleClose}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                    >
                      <Box className="cityfilterClass">
                        <Typography variant="h6" component="h2" gutterBottom>
                          Filter by Amount
                        </Typography>
                        {isLoading ? (
                          <CircularProgress />
                        ) : (
                          <FormControl component="fieldset">
                            {uniqueAmounts &&
                              uniqueAmounts.map((el) => (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={selectedAmount === el.amount}
                                      onChange={() =>
                                        handleCheckboxChange(
                                          el.amount,
                                          "amount"
                                        )
                                      }
                                    />
                                  }
                                  label={el.amount}
                                  key={el.amount}
                                />
                              ))}
                          </FormControl>
                        )}
                      </Box>
                    </Modal> */}
                  </div>

                  <div
                    style={{
                      backgroundColor: "#ffffff",

                      borderRadius: "14px",
                      // width: "100%",

                      height: "78vh",
                      overflowY: "auto",
                      marginBottom:"77px"
                    }}
                    ref={tableContainerRef}
                  >
                    <Table striped>
                      <thead>
                        <tr>
                          <th>
                            
                            <span
                              style={{
                                marginLeft: "10px",
                                cursor: "pointer",
                              }}
                            >
                              Order Date & Time
                            </span>
                          </th>

                          <th>Order ID</th>
                          <th>Mini order ID</th>
                          <th>Phone Number</th>
                          <th>
                            <img
                              style={{
                                position: "relative",
                                cursor: "pointer",
                              }}
                              onClick={handleOpen}
                              src={filterIcon}
                              alt=""
                            />
                            <span style={{ marginLeft: "10px" }}>City</span>
                          </th>

                          <th>
                            Amount
                          </th>
                          {/* <th> Status</th> */}
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredList && filteredList.length ? (
                          filteredList &&
                          filteredList.map((el, index) => (
                            <tr
                              key={el.id}
                              style={{ cursor: "pointer" }}
                              className="rowColor"
                              onClick={(e) => handleRowClick(e, el.id)}
                            >
                              <td style={{ textAlign: "left" }}>
                                {moment
                                  .utc(el.createdAt)
                                  .tz("Asia/Kolkata")
                                  .format("YYYY-MM-DD hh:mm:ss A")}
                              </td>
                              <td style={{ textAlign: "left" }}>{el.id}</td>
                              <td>{el.dcCode}</td>
                              <td style={{ textAlign: "left" }}>
                                {el.phone !== null && el.phone !== undefined
                                  ? el.phone
                                  : "N/A"}
                              </td>
                              <td style={{ textAlign: "left" }}>{el.city}</td>
                              <td style={{ textAlign: "left" }}>{el.amount}</td>
                              {/* <td style={{ textAlign: "left" }}>
  <span
    className="tableData"
    style={{
      backgroundColor: rowColors[index % rowColors.length],
    }}
  >
    {el.status !== null && el.status !== undefined ? el.status : "N/A"}
  </span>
</td> */}

                              <td className="eyeicon1">
                                <img src={eyeIcon} loading="lazy" alt="" />
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            {loading ? (
                              <div className="loader">Loading...</div>
                            ) : (
                              <div className="noOrderFound">
                                <div>
                                  <img
                                    className="noOrderImg"
                                    src={emotions7}
                                    alt=""
                                  />
                                  <p className="noOrderPara">No Order Found</p>
                                </div>
                              </div>
                            )}
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  {/* </InfiniteScroll> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OrdersListComp;
